export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    field: 'expand',
    type: 'expand',
    width: 75,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: { content: 'expandContent' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_platform_cust') || '渠道/客户',
    field: 'platformName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 220,
    showHeaderOverflow: true,
    slots: { default: 'platformName' },
  },
  {
    title: that.$l('table_label_custOrderNo') || '客户订单编号',
    field: 'custOrderNo',
    align: 'center',
    minWidth: 150,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_batchDeliveryDate') || '出货日期',
    field: 'deliveryDate',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_beginShippingDate') || '最早发运日期',
    field: 'beginShippingDate',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_endShippingDate') || '最晚发运日期',
    field: 'endShippingDate',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },

  {
    title: that.$l('table_label_wahName') || '仓库',
    field: 'whName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 220,
    showHeaderOverflow: true,
    slots: { default: 'whName' },
  },
  {
    title: that.$l('table_label_batchGoodsQty') || '出货数量',
    field: 'batchGoodsQty',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_batchCtnQty') || '出货箱数',
    field: 'batchCtnQty',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_batchAmount') || '出货金额',
    field: 'batchAmount',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalGrossWeight') || '总毛重(KG)',
    field: 'totalGrossWeight',
    align: 'center',
    width: 100,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalCbm') || '总体积(m³)',
    field: 'totalCbm',
    align: 'center',
    width: 120,
    showOverflow: true,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_region') || '所属地区',
    field: 'regionName',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_dispatchPort') || '出运港口',
    field: 'dispatchPortName',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_evgPackingSchemeName') || '包装方案名称',
    field: 'evgPackingSchemeName',
    align: 'center',
    minWidth: 300,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_createBy') || '创建人',
    field: 'createByName',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    slots: { default: 'createByName' }
  },
]
